import { proxy } from "valtio";
import { enjoyProductChoices } from "./enjoyProductChoices.js";
import { superliteProductChoices } from "./superliteProductChoices.js";
// import { useSnapshot } from "valtio";
// import { state } from "../../context/store";

const productChoices = proxy({
  active: "A",

  // Must return the actual proxy, not a snapshot or wrapped object
  get current() {
    // console.log(this.active);
    return this.active === "A" ? enjoyProductChoices : superliteProductChoices;
  },
});

export { productChoices };
